// Composables
import { scrollIntoView } from '@/composables/helpers/client-only/scroll';

export const skipToContent = () => {
    if (process.server) return;

    const anchor = document.getElementById('main');
    if (anchor) {
        anchor.focus();
        scrollIntoView(anchor);
    }
};
